import React from 'react'
import { Input, InputProps } from 'rsuite'
import FilterField, { FilterFieldSize } from './FilterField'

export interface FilterInputProps extends Omit<InputProps, 'size'> {
  label?: string
  fieldSize?: FilterFieldSize
}

export default function FilterInput ({
  label,
  fieldSize = 'normal',
  ...inputProps
}: FilterInputProps) {
  return (
    <FilterField size={fieldSize} label={label}>
      <Input size="sm" {...inputProps} />
    </FilterField>
  )
}
